/*
    General component
    display UI instead of form field button.
    Displays the file uploaded

    takes in size of image it should resize the image to.
*/
import React, { Component, useCallback } from 'react';

import { loadFileFromImage, imageToUploadSubject, imagePreviewSubject } from '../ImageResize/ImageResize';

const FileUploadDrag = React.forwardRef((props, ref) => {
   const handleBrowseButtonClick = useCallback((event) => {
      event.preventDefault();
      if (props.onBrowseClick) {
         props.onBrowseClick();
      }
      event.stopPropagation();
   });
   return (
      <div ref={ ref }>
         <div className='show-upload-icon'>
            <img src='/employer/images/svgs/upload-image.svg' alt='' height='100%'/>
         </div>
         <div className='upload-hints'>
            Drag and drop to upload Company Logo <br/>
            or <a href='' onClick={ handleBrowseButtonClick }>browse</a> to choose a file.
         </div>
      </div>
   );
});

class FileUpload extends Component {
   subscription = null;

   constructor(props) {
      super(props);

      this.state = {
         uploadedFile: null,
         fileSelectionError: '',
         resizedImage: '',
      };

      this.dropRef = React.createRef();
      this.onChangeHandler = this.onChangeHandler.bind(this);
      this.openFilePicker = this.openFilePicker.bind(this);
   }

   componentDidMount() {
      let div = this.dropRef.current;
      div.addEventListener('dragenter', this.handleDragIn);
      div.addEventListener('dragleave', this.handleDragOut);
      div.addEventListener('dragover', this.handleDrag);
      div.addEventListener('drop', this.handleDrop);
      this.setState({
         resizedImage: '',
      });

      this.subscription = imageToUploadSubject.subscribe((data) => {
         if (this.props.acceptFileInput) {
            this.props.acceptFileInput(data);
         }
      });

      this.previewSubscription = imagePreviewSubject.subscribe((data) => {
         this.setState({
            resizedImage: data,
         });
      });
   }

   componentWillUnmount() {
      let div = this.dropRef.current;
      div.removeEventListener('dragenter', this.handleDragIn);
      div.removeEventListener('dragleave', this.handleDragOut);
      div.removeEventListener('dragover', this.handleDrag);
      div.removeEventListener('drop', this.handleDrop);
      this.setState({
         resizedImage: '',
      });

      imageToUploadSubject.next('');
      imagePreviewSubject.next('');

      if (this.subscription && this.subscription.unsubscribe) {
         this.subscription.unsubscribe();
      }

      if (this.previewSubscription && this.previewSubscription.unsubscribe) {
         this.previewSubscription.unsubscribe();
      }
   }

   onChangeHandler(event) {
      this.setState({
         uploadedFile: event.target.files[0],
      }, () => {
         this.triggerFileResize();
      });
   }

   triggerFileResize() {
      const imageSize = {};

      if (this.props.imageType === 'cover') {
         imageSize.width = 1150;
         imageSize.height = 250;
      } else {
         imageSize.width = 128;
         imageSize.height = 128;
      }

      loadFileFromImage(this.state.uploadedFile, imageSize);
   }

   handleDrag = (e) => {
      e.preventDefault();
      e.stopPropagation();
   };

   handleDragIn = (e) => {
      e.preventDefault();
      e.stopPropagation();
   };

   handleDragOut = (e) => {
      e.preventDefault();
      e.stopPropagation();
   };

   handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
         let files = e.dataTransfer.files;
         if (files.length > 1) {
            this.setState({
               fileSelectionError: 'You can select only 1 file at a time.',
            });
         } else {
            this.setState({
               fileSelectionError: '',
               uploadedFile: e.dataTransfer.files[0],
            }, () => {
               this.triggerFileResize();
            });
         }
      }
   };

   openFilePicker() {
      this.fileInputElement.click();
   }

   render() {
      return (
         <div>
            <div className='imageUploadAccept  has-advanced-upload'>
               <div className='upload_input_wrapper'>
                  <div className='row'>
                     <div className='col-xs-2'>
                        <label htmlFor='' className='control-label'>Logo: </label>
                     </div>
                     <div className='col-xs-10'>
                        <input
                           ref={ (input) => this.fileInputElement = input }
                           className='inputBox inputSmall'
                           type='file'
                           name='file_upload'
                           id='fileUpload'
                           onChange={ this.onChangeHandler }
                        />
                     </div>
                     <div className='col-xs-10 col-xs-offset-2'>
                        <small>File types accepted: GIF, JPG, or PNG. Your Logo will be resized to 128px &times; 128px.</small>
                     </div>
                  </div>
                  <button className='box__button' type='submit'>Upload</button>
               </div>
               <FileUploadDrag ref={ this.dropRef } onBrowseClick={ this.openFilePicker } />
            </div>
            { this.state.resizedImage.length > 0
            && (
               <div>
                  <img src={ this.state.resizedImage } alt='Resized Image' />
               </div>
            )}
         </div>
      );
   }
}

export default FileUpload;
